import { render } from "./EditSystemOrganisationMapping.vue?vue&type=template&id=27f9ab4a"
import script from "./EditSystemOrganisationMapping.vue?vue&type=script&lang=js"
export * from "./EditSystemOrganisationMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__